import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { BroadcastingElementBasic } from 'src/app/models/broadcastings-models/broadcasting-element-basic.model';
import { MediaGalleryItem } from 'src/app/components/shared-components/media-gallery/media-gallery-item/media-gallery-item.model';
import { EMPTY, Subscription } from 'rxjs';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { MediaGalleryComponent } from 'src/app/components/shared-components/media-gallery/media-gallery.component';
import { MatDialog } from '@angular/material/dialog';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-broadcasting-gallery-card',
  templateUrl: './broadcastings-broadcasting-gallery-card.component.html',
  styleUrls: ['./broadcastings-broadcasting-gallery-card.component.scss']
})
export class BroadcastingsBroadcastingGalleryCardComponent implements OnInit, OnDestroy {

  @ViewChild('mediaGallery', { static: false }) mediaGallery: MediaGalleryComponent;
  gallery;
  broadcasting;
  updateBroadcastingElementsSubscription: Subscription;
  forceBroadcastingUpdateSubscription: Subscription;
  @Input() public set inBroadcasting(broadcasting) {
    if (broadcasting) {
      this.gallery = new Array<MediaGalleryItem>();
      this.broadcasting = broadcasting;
      broadcasting.BroadcastingElements.forEach(
        (e) => {
          this.gallery.push(this.parseElement(e));
        }
      );
    }
  }

  constructor(private broadcastingsService: BroadcastingsService,
              private snackbarService: SnackBarService,
              private spinnerService: SpinnerService,
              private dialog: MatDialog) {
                this.gallery = new Array<MediaGalleryItem>();
              }

  ngOnInit() { }

  public outputEventReceiver(elements) {
    const broadcastingElements = new Array<BroadcastingElementBasic>();
    for (let i = 0; i < elements.length; i++) {
      const broadcastingElement = this.unparseElement(elements[i]);
      broadcastingElement.OrderClip = i + 1;
      broadcastingElements.push(broadcastingElement);
    }
    this.updateBroadcastingElements(broadcastingElements);
  }

  public updateBroadcastingElements(broadcastingElements) {
    this.spinnerService.show('broadcasting-gallery-spinner');
    this.updateBroadcastingElementsSubscription = this.broadcastingsService.updateBroadcastingGallery(this.broadcasting.BroadcastingInternalId, this.broadcasting.Active, this.broadcasting.ShowApp, broadcastingElements).pipe(
      tap(o => this.snackbarService.open('broadcastings-page.snackbar messages.update broadcasting success', 'success')),
      tap(o => this.spinnerService.hide('broadcasting-gallery-spinner')),
      tap(o => this.broadcastingsService.refreshBroadcasting()),
      catchError(error => { this.spinnerService.hide('broadcasting-gallery-spinner'); this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public forceBroadcastingUpdate() {
    this.forceBroadcastingUpdateSubscription = this.broadcastingsService.forceBroadcastingUpdate(this.broadcasting.BroadcastingInternalId).pipe(
      tap(o => this.spinnerService.hide('broadcasting-update-spinner')),
      tap(o => this.snackbarService.open('broadcastings-page.snackbar messages.broadcasting force update success', 'success')),
      catchError(error => { this.spinnerService.hide('broadcasting-update-spinner'); this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public parseElement(element: BroadcastingElementBasic) {
    const mediaGalleryItem = new MediaGalleryItem();
    element.BroadcastingElementInternalId ? mediaGalleryItem.Id = element.BroadcastingElementInternalId : mediaGalleryItem.Id = null;
    element.UrlElement ? mediaGalleryItem.Content = element.UrlElement : mediaGalleryItem.Content = null;
    element.UrlElementThumbnail ? mediaGalleryItem.ContentThumbnail = element.UrlElementThumbnail : mediaGalleryItem.ContentThumbnail = null;
    element.TitleElement ? mediaGalleryItem.Title = element.TitleElement : mediaGalleryItem.Title = 'untitled';
    switch (element.Type) {
      case 'IMAGE':
        mediaGalleryItem.Type = 'IMAGE_URL';
        element.TimeClip ? mediaGalleryItem.Duration = element.TimeClip : mediaGalleryItem.Duration = 60;
      break;
      case 'VIDEO':
        mediaGalleryItem.Type = 'VIDEO_URL';
        element.Cycles ? mediaGalleryItem.Cycles = element.Cycles : mediaGalleryItem.Cycles = 1;
      break;
      case 'YOUTUBE':
        mediaGalleryItem.Type = 'VIDEO_YOUTUBE';
        element.Cycles ? mediaGalleryItem.Cycles = element.Cycles : mediaGalleryItem.Cycles = 1;
      break;
      case 'WEBSCRIPT':
        mediaGalleryItem.Type = 'WEB_SCRIPT';
        element.TimeClip ? mediaGalleryItem.Duration = element.TimeClip : mediaGalleryItem.Duration = 60;
        element.ZoomLevel ? mediaGalleryItem.ZoomLevel = element.ZoomLevel : mediaGalleryItem.ZoomLevel = 100;
      break;
      case 'WEBURL':
        mediaGalleryItem.Type = 'WEB_URL';
        element.TimeClip ? mediaGalleryItem.Duration = element.TimeClip : mediaGalleryItem.Duration = 60;
        element.ZoomLevel ? mediaGalleryItem.ZoomLevel = element.ZoomLevel : mediaGalleryItem.ZoomLevel = 100;
      break;
    }
    return mediaGalleryItem;
  }

  private unparseElement(element) {
    const item = new BroadcastingElementBasic();
    item.BroadcastingElementInternalId = null;
    element.Content ? item.UrlElement = element.Content : item.UrlElement = null;
    element.ContentThumbnail ? item.UrlElementThumbnail = element.ContentThumbnail : item.UrlElementThumbnail = null;
    element.Title ? item.TitleElement = element.Title : item.TitleElement = null;
    switch (element.Type) {
      case 'IMAGE':
        item.Type = 'IMAGE';
        element.Duration ? item.TimeClip = element.Duration : item.TimeClip = 60;
        item.Cycles = null;
        break;
        case 'IMAGE_URL':
        item.Type = 'IMAGE';
        element.Duration ? item.TimeClip = element.Duration : item.TimeClip = 60;
        item.Cycles = null;
      break;
      case 'VIDEO':
        item.Type = 'VIDEO';
        item.TimeClip = null;
        element.Cycles ? item.Cycles = element.Cycles : item.Cycles = 1;
      break;
      case 'VIDEO_URL':
        item.Type = 'VIDEO';
        item.TimeClip = null;
        element.Cycles ? item.Cycles = element.Cycles : item.Cycles = 1;
      break;
      case 'VIDEO_YOUTUBE':
        item.Type = 'YOUTUBE';
        item.TimeClip = null;
        element.Cycles ? item.Cycles = element.Cycles : item.Cycles = 1;
      break;
      case 'WEB_SCRIPT':
        item.Type = 'WEBSCRIPT';
        item.Cycles = null;
        element.Duration ? item.TimeClip = element.Duration : item.TimeClip = 60;
        element.ZoomLevel ? item.ZoomLevel = element.ZoomLevel : item.ZoomLevel = 100;
      break;
      case 'WEB_URL':
        item.Type = 'WEBURL';
        item.Cycles = null;
        element.Duration ? item.TimeClip = element.Duration : item.TimeClip = 60;
        element.ZoomLevel ? item.ZoomLevel = element.ZoomLevel : item.ZoomLevel = 100;
      break;
      default:
        item.Type = null;
        item.TimeClip = null;
        item.Cycles = null;
      break;
    }
    return item;
  }

  public multimediaManager() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: true } });
    dialogRef.beforeClosed().subscribe(
      (res) => {
        if (res && (res.length > 0)) {
          const dialogReponseItems = new Array<MediaGalleryItem>();
          res.forEach(
            (i) => this.gallery.push(this.toGalleryItem(i))
          );
          this.outputEventReceiver(this.gallery);
        }
      }
    );
  }

  public toGalleryItem(item) {
    const mgItem = new MediaGalleryItem();

    item.InternalId ? mgItem.Id = item.InternalId : mgItem.Id = null;
    item.Name ? mgItem.Title = item.Name : mgItem.Title = null;
    item.Url ? mgItem.Content = item.Url : mgItem.Content = null;
    item.UrlThumbnail ? mgItem.ContentThumbnail = item.UrlThumbnail : mgItem.ContentThumbnail = null;
    switch (item.Type) {
      case 'IMAGE':
      mgItem.Type = 'IMAGE_URL';
      item.TimeClip ? mgItem.Duration = item.TimeClip : mgItem.Duration = 60;
      break;
      case 'VIDEO':
        mgItem.Type = 'VIDEO_URL';
        item.Cycles ? mgItem.Cycles = item.Cycles : mgItem.Cycles = 1;
      break;
      case 'YOUTUBE':
        mgItem.Type = 'VIDEO_YOUTUBE';
        item.Cycles ? mgItem.Cycles = item.Cycles : mgItem.Cycles = 1;
      break;
      case 'WEBSCRIPT':
        mgItem.Type = 'WEB_SCRIPT';
        item.TimeClip ? mgItem.Duration = item.TimeClip : mgItem.Duration = 60;
        item.ZoomLevel ? mgItem.ZoomLevel = item.ZoomLevel : mgItem.ZoomLevel = 100;
      break;
      case 'WEBURL':
        mgItem.Type = 'WEB_URL';
        item.TimeClip ? mgItem.Duration = item.TimeClip : mgItem.Duration = 60;
        item.ZoomLevel ? mgItem.ZoomLevel = item.ZoomLevel : mgItem.ZoomLevel = 100;
      break;
    }

    return mgItem;
  }
  ngOnDestroy() {
    if (this.updateBroadcastingElementsSubscription) { this.updateBroadcastingElementsSubscription.unsubscribe(); }
    if (this.forceBroadcastingUpdateSubscription) { this.forceBroadcastingUpdateSubscription.unsubscribe(); }
  }
}
